module.exports = __webpack_public_path__ + "assets/img/flash@1,5x.6347de7b.svg";